import { IStaffConfirmationStatus } from '#entities/staff'
import { httpClient, resolveApiUrl } from '#shared/api'
import GetStaffListResponse from '../model/get-staff-list-response'

interface GetStaffListOptions {
  confirmationStatus?: IStaffConfirmationStatus | null
  pageNumber?: number
  count?: number
}

export default async function getStaffList({ confirmationStatus, pageNumber = 0, count = 20 }: GetStaffListOptions) {
  const searchParams = new URLSearchParams([
    ['pageNumber', pageNumber.toString()],
    ['pageSize', count.toString()],
  ])

  if (typeof confirmationStatus === 'number') {
    searchParams.set('confirmationStatus', confirmationStatus.toString())
  }

  const response = await httpClient.get<GetStaffListResponse>('users/get-all-staff?' + searchParams.toString(), {
    prefixUrl: resolveApiUrl('@sd-users'),
  })
  const responseBody = await response.json()

  return responseBody
}
